import { combineReducers } from "redux";

import State from "../../../domain/entities/State";
import administrator from "./administrator";
import archive from "./archive";
import requestor from "./requestor";
import session from "./session";
import signatory from "./signatory";

const rootReducer = combineReducers<State>({
  administrator,
  archive,
  requestor,
  session,
  signatory,
});

export default rootReducer;
export type RootState = ReturnType<typeof rootReducer>;
